import {
  GET_SINGLE_NEWS_LOADING,
  GET_SINGLE_NEWS_SUCCESS,
  GET_SINGLE_NEWS_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";
import { singleNewsUrl } from "api/apiUrls";

export const singleNewsAction = (id?: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_NEWS_LOADING, payload: true });
    const response = await listSingleItemService(`${singleNewsUrl}${id}`, "");

    dispatch({ type: GET_SINGLE_NEWS_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: GET_SINGLE_NEWS_FAILURE, payload: err });
  } finally {
    dispatch({ type: GET_SINGLE_NEWS_LOADING, payload: false });
  }
};
